<template>
  <div class="online-cv-preview" :style="iosOrAndroidStyle">
    <w-nav-bar @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow">
      <div slot="rightContent" class="flex-start cv-preview-header" @click="toSetPrivacy">
        <i class="iconfont iconshezhi" />
        <span>隐私设置</span>
      </div>
    </w-nav-bar>
    <div class="preview-tool-tips">
      <i class="iconfont iconcuowu"></i>
      <p>为便于HR浏览，在线简历中的各段经历将按照时间倒序排列</p>
    </div>
    <div class="online-cv-container" v-if="resumeInfo">
      <div class="profile-content flex">
        <div class="profile-info">
          <p class="username">{{ profileData.username }}</p>
          <div class="user-intention">
            <p>
              <span v-if="workExperience">{{ workExperience }}</span>
              <template v-if="onlineCvData.profession_identity && onlineCvData.profession_identity === '已工作'">
                <span v-if="companyName">{{ companyName }}</span>
                <span v-if="degreeName">{{ degreeName }}</span>
              </template>
              <template v-else>
                <span v-if="schoolName">{{ schoolName }}</span>
                <span v-if="degreeName">{{ degreeName }}</span>
              </template>
            </p>

            <!-- 求职意向 -->
            <p>
              求职意向：
              <span v-if="intentionCity">{{ intentionCity }}</span>
              <span v-if="intentionJob">{{ intentionJob }}</span>
              <span v-if="intentionSalary">{{ intentionSalary }}</span>
              <i v-if="intentionIconVisible" class="intention-icon iconfont iconcuowu" @click="showToIntentionDialogFunc()"></i>
            </p>

            <!-- <p v-if="profileData.expected_salary || profileData.exp_job">
              <span v-if="profileData.expected_salary">{{ profileData.expected_salary }}</span>
              <span v-if="profileData.exp_job">{{ profileData.exp_job }}</span>
            </p> -->

            <p v-if="profileData.address">地址：{{ profileData.address }}</p>
            <p v-if="profileData.homepage">个人网站：{{ profileData.homepage }}</p>
            <p v-if="profileData.age || profileData.gender || profileData.height || profileData.weight">
              个人信息：
              <span v-if="profileData.age">{{ profileData.age }}</span>
              <span v-if="profileData.gender">{{ profileData.gender }}</span>
              <span v-if="profileData.height">{{ profileData.height }}</span>
              <span v-if="profileData.weight">{{ profileData.weight }}</span>
            </p>
            <p v-if="profileData.ethnic">民族：{{ profileData.ethnic }}</p>
            <p v-if="profileData.hometown">籍贯：{{ profileData.hometown }}</p>
            <p v-if="profileData.marriage">婚姻状况：{{ profileData.marriage }}</p>
            <p v-if="profileData.political_status">政治面貌：{{ profileData.political_status }}</p>
          </div>
        </div>
        <div class="avatar-content">
          <img :src="profileData.avatar_url" alt="">
        </div>
      </div>
      <div class="tab-wrapper" :class="{'ios-tab-wrapper': isIos}">
        <w-tab :tab-list="tabList" :current-tab="currentTab" @changeTab="changeTab"/>
      </div>
      <div class="infos-wrapper" v-if="currentTab === 0">
        <!-- <template v-for="(item, index) in moduleData"> -->
          <!-- <div :key="index" class="module-wrapper" v-if="_notEmpty(item.module, item.infos)"> -->
          <div class="module-wrapper">

            <!-- <div class="person-info" :id="item.module">
              <div class="title flex-between" :class="{'other-section-title': item.module === 'other'}">
                <div class="header-left flex">
                  <span class="module-title">{{item.title}}</span>
                </div>
              </div>
              <template v-for="val in item.infos">
                <div class="list-item" :key="val.id" v-if="item.module !== 'other'">
                  <div class="flex-between item-title" v-if="val.name || val.university || val.company_name">
                    <span v-if="val.name">{{val.name}}</span>
                    <span v-if="val.university">{{val.university}}</span>
                    <span v-if="val.company_name">{{val.company_name}}</span>
                  </div>
                  <div class="dept"
                       v-if="val.city || val.major || val.degree || val.dept || val.cust_uni_school || val.title">
                    <span v-if="val.city">{{ val.city }}</span>
                    <span v-if="val.major">{{ val.major }}</span>
                    <span v-if="val.degree">{{val.degree }}</span>
                    <span v-if="val.dept">{{ val.dept }}</span>
                    <span v-if="val.cust_uni_school">{{val.cust_uni_school}}</span>
                    <span v-if="val.title">{{ val.title }}</span>
                  </div>
                  <div class="desc" v-if="val.start_at || val.end_at || val.present">
                    <span>{{ `${val.start_at} - ` }}{{ val.end_at }}</span>
                    <span v-if="val.present">{{ val.present }}</span>
                  </div>
                  <div v-if="val.description" v-html="val.description" class="change-desc"></div>
                </div>
                <li class="change-desc" :key="val.id"
                    v-if="item.module === 'other' && val.info && val.info.description">
                  <span>{{val.title}}</span>
                  <span>{{val.info.description}}</span>
                </li>
              </template>
            </div> -->

            <cv-preview-content :info="onlineCvData.resume.info" />
          </div>
        <!-- </template> -->
      </div>
      <div class="contact-wrapper" v-if="currentTab === 1">

        <div class="contact-box">
          <template v-if="contactDirectlyVisible">
            <span>联系方式在推荐简历中已隐藏，HR需与你交换联系方式后才可查看</span>
          </template>
          <template v-else>
            <span>开启极速联系，允许 HR 主动与你交换联系方式，提升求职效率</span>
            <span class="contact-btn" @click="setPersonPrivacyFunc()">立即开启</span>
          </template>
        </div>

        <div class="contact-item flex">
          <div class="icon-wrapper flex-center">
            <span class="iconfont icondianhua"/>
          </div>
          <div class="content flex-column">
            <span class="label">手机号码</span>
            <span class="container">{{ profileData.phone }}</span>
          </div>
        </div>
        <div class="contact-item flex">
          <div class="icon-wrapper flex-center">
            <span class="iconfont iconyouxiang1"/>
          </div>
          <div class="content flex-column">
            <span class="label">联系邮箱</span>
            <span class="container">{{ profileData.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import WTab from '@/components/global/w-tab'
	import { workingYears } from '../../assets/js/utils'
	import { mapState, mapMutations, mapActions } from 'vuex'
	import Cookies from 'js-cookie'
  import { envMixin, eventMixin } from '../../assets/js/mixin/global'
  import cvPreviewContent from './cvPreviewContent'
	import { componentsMixin } from '@/assets/js/mixin/components'
  const moment = require('moment')

	export default {
		name: 'online-preview',
		mixins: [ eventMixin, envMixin, componentsMixin ],
		data () {
			return {
				moduleData: [],
				tabList: [ { label: '在线简历' }, { label: '联系方式' } ],
				currentTab: 0,
        userIdentity: null, // 用户身份
        contactDirectlyVisible: true // 用户直接联系开关 visible 
			}
		},
		async mounted () {
      this.getPersonPrivacy(this.cvAccountToken)
      this.getCommunityInfo(this.cvAccountToken)
			await this.getOnlineCvData(this.cvAccountToken)
      this._dealCvData()
		},
		computed: {
			...mapState('cv', [ 'onlineCvData' ]),
			cvAccountToken () {
				let _t = Cookies.get('_t')
				let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
				return tokenPayload.User.c_t
			},
			resumeInfo () {
				return this.onlineCvData.resume && this.onlineCvData.resume.info
			},
			// 基本信息
			profileData () {
				return this.resumeInfo.profile
			},
			// 公司名称
			companyName () {
				if (this.resumeInfo.work_experiences.length) {
					return this.resumeInfo.work_experiences[0].company_name
				} else if (this.resumeInfo.internship_experiences.length) {
          return this.resumeInfo.internship_experiences[0].company_name
        }
			},
			// 学校名称
			schoolName () {
				let info = this.resumeInfo.education_experiences[this.onlineCvData.recent_edu_index]
				if (info.cust_uni_name || (info.school && info.school.cn)) {
					return info.cust_uni_name || info.school && info.school.cn
				}
			},
			// 学历名称
			degreeName () {
				let info = this.resumeInfo.education_experiences[this.onlineCvData.recent_edu_index]
				if (info.cust_degree || (info.degree_name && info.degree_name.cn)) {
					return info.cust_degree || info.degree_name && info.degree_name.cn
				}
			},
			// 工作经验
			workExperience () {
				return workingYears(this.onlineCvData.profession_identity, this.onlineCvData.years_of_work_experience)
			},
      // 求职意向城市
      intentionCity () {
        if (this.onlineCvData.resume.info.basic_info.expected_location && this.onlineCvData.resume.info.basic_info.expected_location.length) {
          return this.onlineCvData.resume.info.basic_info.expected_location.join('/')
        } else if (this.onlineCvData.resume.info.basic_info.predict_cities && this.onlineCvData.resume.info.basic_info.predict_cities.length) {
          return this.onlineCvData.resume.info.basic_info.predict_cities.join('/')
        } else {
          return null
        }
      },
      // 求职意向职位
      intentionJob () {
        if (this.onlineCvData.resume.info.profile.exp_job) {
          return this.onlineCvData.resume.info.profile.exp_job
        } else if (this.onlineCvData.resume.info.basic_info.exp_job) {
          return this.onlineCvData.resume.info.basic_info.exp_job
        } else {
          return null
        }
      },
      // 求职意向薪资
      intentionSalary () {

        if (this.userIdentity === 'already_work') {

          if (this.onlineCvData.resume.info.profile.expected_salary) {
            return this.onlineCvData.resume.info.profile.expected_salary
          } else if (this.onlineCvData.resume.info.basic_info.expected_salary) {
            return this.onlineCvData.resume.info.basic_info.expected_salary
          } else {
            return '面议'
          }

        } else if (this.userIdentity === 'student') {

          if (this.onlineCvData.resume.info.profile.expected_salary) {
            return this.onlineCvData.resume.info.profile.expected_salary
          } else {
            return '面议'
          }

        } else {
          return '面议'
        }

      },
      // 是否显示求职意向 icon
      intentionIconVisible () {
        // 身份 职场人
        if (this.userIdentity === 'already_work') {
          return !this.onlineCvData.resume.info.basic_info.expected_location || !this.onlineCvData.resume.info.basic_info.expected_location.length || !this.onlineCvData.resume.info.basic_info.exp_job || !this.onlineCvData.resume.info.basic_info.expected_salary
        // 身份 学生
        } else if (this.userIdentity === 'student') {
          return !this.onlineCvData.resume.info.basic_info.expected_location || !this.onlineCvData.resume.info.basic_info.expected_location.length || !this.onlineCvData.resume.info.basic_info.exp_job
        } else {
          return false
        }
      }
		},
		watch: {},
		components: {
			WNavBar,
      WTab,
      cvPreviewContent
		},
		methods: {
			...mapActions('cv', [ 'getOnlineCvData' ]),
      ...mapMutations('user', [ 'setIsOnlineCv']),
 
      // 获取个人隐私设置
      async getPersonPrivacy(cvAccountToken) {
			  try {
          let res = await this.$api.user.getPersonPrivacy(cvAccountToken)
          if (res.code === 1000) {
            this.contactDirectlyVisible = res.data.contact_directly
          }
        } catch (e) {
			    console.error(e)
        }
      },
      // 设置隐私设置
      async setPersonPrivacyFunc() {
        try {
          let res = await this.$api.user.setPersonPrivacy(this.cvAccountToken, {contact_directly: true})
          if (res.code === 1000) {
            this.showToast('开启成功')
            this.contactDirectlyVisible = true
          }
        } catch (error) {
          console.error(error)
        }
      },
      // 获取用户身份
      async getCommunityInfo (cvAccountToken) {
        try {
          let res = await this.$api.community.getCommunityInfo(cvAccountToken)
          if (res.code = 1000) {
            this.userIdentity = res.data.status
          }
        } catch (error) {
          console.log(error)
        }
      },
      showToIntentionDialogFunc () {
        this.$createDialog({
          title: '修改求职意向',
          type: 'confirm',
          content: `当前求职意向为根据简历预测的结果，可手动设置求职意向，提高求职成功率`,
          confirmBtn: {
            text: '立即修改',
          },
          cancelBtn: {
            text: '暂不修改',
          },
          onConfirm: () => {
            this.setIsOnlineCv(true)
            window.location.href = `${process.env.VUE_APP_HOST}/job/intentions`
          }
        }).show()
      },
			changeTab (item, index) {
				this.currentTab = index
			},
			routerBack () {
				this.$router.replace({ path: '/cvs', query: { cvsRecommendState: true } })
			},
			dealTime (time) {
				if (!time) return ''
				if (time.includes('-')) {
					return moment(time).format('YYYY.MM')
				} else {
					return time
				}
			},
			_dealCvData () {
				let { basic_info: { sections_position }, custom_sections } = this.resumeInfo
				let otherSort = [
					{
						titleField: 'skills',
						infoField: 'skills'
					},
					{
						titleField: 'languages',
						infoField: 'languages'
					},
					{
						titleField: 'certificates',
						infoField: 'certificates'
					},
					{
						titleField: 'else',
						infoField: 'others'
					},
					{
						titleField: 'interests',
						infoField: 'interests'
					},
				]
				let moduleData = []
				sections_position.forEach(item => {
					if (item.id) {
						const index = custom_sections.findIndex(value => item.id === value.id)
            if (index > -1) {
            	moduleData.push({
                title: custom_sections[index].section_title,
                infos: custom_sections[index].custom_section_infos
              })
            }
          } else if (item.type === 'extras') {
						let otherInfos = []
						otherSort.forEach(v => {
							otherInfos.push({
								title: this.resumeInfo.basic_info[`${ v.titleField }_title`],
								info: this.resumeInfo[v.infoField][0]
							})
						})
						moduleData.push({
							module: 'other',
							title: this.resumeInfo.basic_info.other_title,
							infos: otherInfos
						})
					} else {
						moduleData.push({
							title: this.resumeInfo.basic_info[`${ item.type.slice(0, -1) }_title`],
							infos: item.type === 'edus' ? this.resumeInfo.education_experiences : item.type === 'works' ? this.resumeInfo.work_experiences : this.resumeInfo.orgs
						})
					}
				})
				moduleData.forEach(item => {
					if (item.module !== 'other') {
						item.infos.forEach(val => {
							val.city = val.cust_city_name || (val.city_name instanceof Object ? val.city_name.cn : val.city_name)
							val.degree = val.cust_degree || val.degree_name && val.degree_name.cn
							val.major = val.cust_major_name || val.major_name && val.major_name.cn
							val.university = val.cust_uni_name || val.school && val.school.cn
							val.start_at = this.dealTime(val.start_at)
							val.end_at = this.dealTime(val.end_at)
						})
					}
				})
				this.moduleData = moduleData
			},
			// 预览时某个模块下什么也没有不显示这个模块
			_notEmpty (section, infos) {
				let fields = [
					'company_name',
					'university',
					'major',
					'degree',
					'cust_uni_school',
					'city',
					'dept',
					'title',
					'name',
					'start_at',
					'end_at',
					'present',
					'description'
				]
				if (section === 'other') {
					for (let i = 0; i < infos.length; i++) {
						if (infos[i].info && infos[i].info.description) return true
					}
				} else if (infos && !infos.length) {
					return false
				} else if (infos instanceof Array) {
					for (let i = 0; i < infos.length; i++) {
						for (let j = 0; j < fields.length; j++) {
							if (infos[i][fields[j]]) return true
						}
					}
				}
			},
      toSetPrivacy() {
        this.$router.push({
          path: '/account/privacy',
          query: {
            pageSource: 'preview'
          }
        })
      }
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/cv/mobile-cv';
  .online-cv-preview {
    padding-top: 44px;
    @include ipx-content-bottom(1px);
    .mobile-nav {
      border-bottom: none;
      .cv-preview-header {
        color: $color-dark-gray;
        i {
          margin-right: 6px;
          font-size: 18px;
          font-weight: 500;
        }
        span {
          font-size: $font-size-medium-x;
          color: $color-dark-gray;
        }
      }
    }
    .preview-tool-tips {
      display: flex;
      color: #4183FF;
      align-items: flex-start;
      padding: 9px 20px;
      background-color: #F5F8FF;
      i {
        margin-right: 8px;
      }
      p {
        line-height: 20px;
      }
    }
    .online-cv-container {
      .profile-content {
        padding: 30px 20px 22px;
        align-items: flex-start;
        .profile-info {
          flex: 1;
          .username {
            color: $color-title;
            font-size: 26px;
            line-height: 26px;
            font-weight: 500;
            margin-bottom: 12px;
          }
          .user-intention {
            p {
              color: $color-dark-gray;
              margin-bottom: 10px;
              span {
                line-height: 18px;
                &::after {
                  content: '|';
                  margin: 0 6px;
                }
                &:last-of-type::after {
                  content: '';
                  margin: 0;
                }
              }
            }

            .intention-icon {
              font-size: 16px;
              line-height: 18px;
              color: #ff6644;
              margin-left: 4px;
            }
          }
        }
        .avatar-content {
          width: 68px;
          margin-left: 24px;
          img {
            width: 68px;
          }
        }
      }
      .tab-wrapper {
        padding-top: 14px;
        border-bottom: 1px solid #EDEEF0;
        position: -webkit-sticky;
        position: sticky;
        top: 43px;
        background-color: $color-light;
        z-index: 10;
        .tab {
          width: 50vw;
          margin-left: 6px;
        }
      }
      .ios-tab-wrapper {
        position: -webkit-sticky;
        position: sticky;
        top: 88px;
      }
      .infos-wrapper {
        padding: 0 24px;
      }
      .contact-wrapper {
        padding: 35px 20px;

        .contact-box {
          padding: 12px 16px;
          background: #F9F9F9;
          border-radius: 6px;
          margin-bottom: 24px;

          >span {
            font-size: 14px;
            font-weight: 400;
            color: #606060;
            line-height: 20px;
          }

          .contact-btn {
            color: #4183FF;
            margin-left: 12px;
          }
        }

        .contact-item {
          align-items: center;
          margin-bottom: 44px;
          .icon-wrapper {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            border: 1px solid #D8D8D8;
            margin-right: 16px;
            .iconfont {
              font-size: 20px;
              color: #BEBEBE;
            }
          }
          .content {
            .label {
              color: $color-dark-gray;
              font-size: $font-size-small;
              margin-bottom: 6px;
            }
            .container {
              color: $color-title;
              font-size: $font-size-large;
            }
          }
        }
      }
      .module-wrapper {
        margin-top: 29px;
      }
    }
  }
</style>
